import React from 'react';
import { graphql } from 'react-apollo';
import { Tooltip } from 'react-tippy';
import DELETE_ARTIST_MUTATION from '../../../../graphql/DeleteArtist';

class DeleteArtist extends React.Component {
  alertDelete = () => {
    if(window.confirm('¿Estás seguro que deseas eliminar este artista?')){
      this.deleteArtist();
    }
  }
  
  deleteArtist = () => {
    const { mutate, id } = this.props;
    mutate({
      variables: {
        id,
      },
    })
      .then((result) => {
        if (typeof this.props.onDelete === 'function') {
          this.props.onDelete(result.data.deleteArtist);
        }
      })
      .catch(() => {
        if (typeof this.props.onDelete === 'function') {
          this.props.onDelete(false);
        }
      });
  };

  render() {
    return (
      <Tooltip
        title="Eliminar"
        position="bottom"
        trigger="mouseenter"
        followCursior
      >
        <button onClick={e => this.alertDelete(e.target)} className="btn btn-adm">
          <i className="fa fa-trash-o" aria-hidden="true" />
        </button>
      </Tooltip>
    );
  }
}
const withMutation = graphql(DELETE_ARTIST_MUTATION);

export default withMutation(DeleteArtist);



// WEBPACK FOOTER //
// ./src/containers/Admin/Artist/Delete/index.js